import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=bc1d7c58&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1d7c58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc1d7c58')) {
      api.createRecord('bc1d7c58', component.options)
    } else {
      api.reload('bc1d7c58', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=bc1d7c58&scoped=true&", function () {
      api.rerender('bc1d7c58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2vjqNx6Xa4pAF/JS/comp/SearchFilterTokens.vue"
export default component.exports